import BeforeSigningModal from 'components/QuestionnaireRequestAutomated/processor/modal/beforeSigningModal'
import { setStep, STEPS } from 'components/QuestionnaireRequestAutomated/processor/slices/interstitialSlice'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ModalContextProvider } from 'plugins/plugins/leases_plugin/javascripts/ModalContext'
import Form from 'components/form'
import Header from '../SignEditHeader'
import {
  selectAnySignedSigntures,
  selectIncompletedFields,
  selectMarkedNaFields,
} from 'components/QuestionnaireRequestAutomated/processor/slices/formInstanceSlice'

export default function Sign() {
  const dispatch = useDispatch()
  const [openSigningModal, setOpenSigningModal] = useState(false)
  const formInstanceId = useSelector((state) => state.global.formInstanceId)
  const numberIncompletedFields = useSelector(selectIncompletedFields).length
  const numberMarkedNaFields = useSelector(selectMarkedNaFields).length
  const isAnySignedSignatures = useSelector(selectAnySignedSigntures)

  useEffect(() => {
    if (!isAnySignedSignatures && numberIncompletedFields > 0 && numberMarkedNaFields > 0) {
      setTimeout(() => {
        setOpenSigningModal(true)
      }, 1000)
    }
  }, [isAnySignedSignatures, numberIncompletedFields, numberMarkedNaFields])

  return (
    <div style={{ height: '100%' }}>
      <Header />
      <div className="questionnaire-request-interstitial-sign-container">
        <div className="questionnaire-request-interstitial-sign-content dome-relative">
          <ModalContextProvider>
            <Form form_id={formInstanceId} viewOnly={false} signing={true} canSign={true} />
          </ModalContextProvider>
        </div>
      </div>
      <BeforeSigningModal
        open={openSigningModal}
        onClose={() => setOpenSigningModal(false)}
        onEdit={() => {
          setOpenSigningModal(false)
          dispatch(setStep(STEPS.edit))
        }}
      />
    </div>
  )
}
